import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/builders/$builder_id/home-plans/$home_plan_id/sales-view")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/builders/$builder_id/home-plans/$home_plan_id/showroom",
      params: { builder_id: params.builder_id, home_plan_id: params.home_plan_id },
      statusCode: 301,
    });
  },
});
